import { Option } from '@components/Formik/MultiSelectFilter/types';

export const getValuesFromOptions = (
  options: Option[],
  keyToMap: keyof Option = 'value'
) => options.map(option => option[keyToMap]);
